export default __webpack_public_path__ + "static/media/pdfbg.867e9bc4.png";